/**
 * AI回答の引用元ページチップ一覧
 * クリックすると onPageJump 経由で既存のPDFページ遷移（handlePageChange）を呼び出す
 *
 * @param {Object} props
 * @param {Array<Object>} props.sources - AI回答が根拠とした引用元一覧
 * @param {string} props.sources[].blob_name - 引用元文書のBlob名
 * @param {number[]} props.sources[].pages - 引用元のページ番号一覧（複数ページにまたがる場合あり）
 * @param {string|null} props.sources[].heading - 引用元の見出し（無い場合はnull）
 * @param {(pageNumber: number) => void} props.onPageJump - チップクリック時に呼ばれるPDFページ遷移ハンドラ
 */
const SourceCitationChips = ({ sources, onPageJump }) => {
  if (!sources || sources.length === 0) return null;

  return (
    <div className="ai-source-refs">
      {sources.map((source, index) => {
        const pageLabel = source.pages && source.pages.length > 1
          ? `${source.pages[0]}-${source.pages[source.pages.length - 1]}ページ`
          : `${source.pages?.[0] ?? ''}ページ`;
        const firstPage = source.pages?.[0];

        return (
          <button
            key={`${source.blob_name}-${index}`}
            type="button"
            className="ai-source-chip"
            onClick={() => firstPage && onPageJump(firstPage)}
            disabled={!firstPage}
          >
            <span className="ai-source-chip-icon">📄</span>
            {pageLabel}
            {source.heading ? `（${source.heading}）` : ''}
          </button>
        );
      })}
    </div>
  );
};

export default SourceCitationChips;
